// Meta Pixel setup for REALMANIFESTACIÓN.
// Loads the base pixel once, fires PageView + ViewContent exactly once,
// and preserves fbclid + UTM attribution toward the Shopify checkout.
// It NEVER fires AddToCart / InitiateCheckout / Purchase from the landing —
// those belong exclusively to Shopify (checkout + Thank You page).

const PIXEL_ID = '3326804787497839'

let initialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  // Idempotent: guard against React re-mounts / StrictMode double-invoke
  // so PageView + ViewContent never duplicate.
  if (initialized) return
  initialized = true

  const w = window as any

  // Standard Meta Pixel base code (only injected once).
  if (!w.fbq) {
    const n: any = (w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const s = document.getElementsByTagName('script')[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      document.head.appendChild(t)
    }
  }

  const fbq = w.fbq

  fbq('init', PIXEL_ID)

  // Standard page view — once.
  fbq('track', 'PageView')

  // Product view for this landing — once.
  fbq('track', 'ViewContent', {
    content_name: 'REALMANIFESTACIÓN',
    content_category: 'Manifestación y Desarrollo Personal',
    content_type: 'product',
    value: 19990,
    currency: 'ARS',
  })
}

// Attribution params to carry through to the Shopify checkout.
const ATTRIBUTION_KEYS = [
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
]

// Appends the current page's fbclid + UTM params to a checkout URL so the
// Shopify checkout / Thank You page can attribute the conversion correctly.
export function appendAttribution(url: string): string {
  if (typeof window === 'undefined') return url
  try {
    const current = new URLSearchParams(window.location.search)
    const carry = new URLSearchParams()
    ATTRIBUTION_KEYS.forEach((key) => {
      const value = current.get(key)
      if (value) carry.set(key, value)
    })
    const qs = carry.toString()
    if (!qs) return url
    return url + (url.includes('?') ? '&' : '?') + qs
  } catch {
    return url
  }
}
